import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { inject, observer } from 'mobx-react'
import { Layout, Select, Button, Row, Col, Input, Form } from 'antd'

const { Option } = Select

@inject((store: any) => {
    const { clinicsStore, citiesStore, clinicServicesStore, companiesStore } = store
    return { clinicsStore, citiesStore, clinicServicesStore, companiesStore }
})
@observer
class SearchBar extends Component<any, any> {
    componentDidMount() {
        this.loadStaticData()
    }

    loadStaticData = async () => {
        const { clinicServicesStore, citiesStore, companiesStore } = this.props
        clinicServicesStore.getClinicServices({})
        citiesStore.getCities()
        companiesStore.getCompanies()
    }
    handleFilterChange = (field, value) => {
        const { clinicsStore } = this.props
        if (field == 'company_id' && typeof value == 'string') {
            clinicsStore.setFilter('company_type', value)
        }
        if (field == 'freeSearch') {
            if (value.length >= 3) {
                clinicsStore.setFilter(field, value)
                clinicsStore.getClinics(1)
            } else if (value && value.length == 0) {
                clinicsStore.setFilter(field, value)
                clinicsStore.getClinics(1)
            } else {
                clinicsStore.setFilter(field, value)
                clinicsStore.getClinics(1)
            }
        } else {
            clinicsStore.setFilter(field, value)
            clinicsStore.getClinics(1)
        }
    }
    render() {
        // const {
        //     clinicServicesList,
        //     citiesList,
        //     companiesList,

        // } = this.props
        const { filters, getClinics, resetFilters } = this.props.clinicsStore
        const { citiesStore, clinicServicesStore, companiesStore } = this.props
        return (
            <Form
                onSubmit={e => {
                    e.preventDefault()
                    getClinics(1)
                }}
            >
                <Layout style={{ padding: '0 1rem' }}>
                    <Row gutter={10}>
                        <Col xs={4}>
                            <strong>סינון לפי שם מרפאה</strong>
                            <Input.Search
                                placeholder="חיפוש על פי שם מרפאה או מזהה"
                                value={filters.freeSearch}
                                onChange={e => {
                                    this.handleFilterChange('freeSearch', e.target.value)
                                }}
                                style={{ width: '100%' }}
                            />
                        </Col>
                        <Col xs={4}>
                            <strong>סינון לפי תחום שירות</strong>
                            <Select
                                showSearch
                                value={filters.clinicService_id}
                                placeholder="בחר שירות"
                                onSelect={e => this.handleFilterChange('clinicService_id', e)}
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option.props.children &&
                                    typeof option.props.children === 'string' &&
                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                <Option value={null}>כל השירותים</Option>
                                {clinicServicesStore.clinicServices.map((item, i) => {
                                    return (
                                        <Option key={item.id} value={item.id}>
                                            {item.name}
                                        </Option>
                                    )
                                })}
                            </Select>
                        </Col>
                        <Col xs={4}>
                            <strong>סינון לפי החברות</strong>
                            <Select
                                showSearch
                                value={filters.company_id}
                                placeholder="בחר חברה"
                                onSelect={e => this.handleFilterChange('company_id', e)}
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option.props.children &&
                                    typeof option.props.children === 'string' &&
                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                <Option value={null}>
                                    <span style={{ textDecoration: 'underline', color: 'black' }}>כל החברות</span>
                                </Option>
                                <Option value={'HMO'}>
                                    <span style={{ textDecoration: 'underline', color: 'black' }}>
                                        כל חברות קופת חולים
                                    </span>
                                </Option>
                                {companiesStore.list
                                    .filter(cmp => cmp.type == 'HMO')
                                    .map((item, i) => {
                                        return (
                                            <Option key={item.id} value={item.id}>
                                                {item.name}
                                            </Option>
                                        )
                                    })}
                                <Option value={'INSURANCE'}>
                                    <span style={{ textDecoration: 'underline', color: 'black' }}>כל חברות הביטוח</span>
                                </Option>
                                {companiesStore.list
                                    .filter(cmp => cmp.type == 'INSURANCE')
                                    .map((item, i) => {
                                        return (
                                            <Option key={item.id} value={item.id}>
                                                {item.name}
                                            </Option>
                                        )
                                    })}
                            </Select>
                        </Col>
                        <Col xs={4}>
                            <strong>חיפוש חופשי בעיר</strong>
                            <Select
                                showSearch
                                value={filters.city_id}
                                placeholder="בחר עיר"
                                onSelect={e => this.handleFilterChange('city_id', e)}
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option.props.children &&
                                    typeof option.props.children === 'string' &&
                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                <Option value={null}>כל הערים</Option>
                                {citiesStore.list.map((item, i) => {
                                    return (
                                        <Option key={item.id} value={item.id}>
                                            {item.name}
                                        </Option>
                                    )
                                })}
                            </Select>
                        </Col>
                        <Col xs={4} style={{ paddingTop: '0.6em' }}>
                            <Button
                                style={{ margin: '0' }}
                                onClick={() => {
                                    resetFilters()
                                }}
                            >
                                איפוס חיפוש
                            </Button>

                            <Button type="primary" style={{ margin: '0.8rem 0.5rem 0' }} htmlType="submit">
                                חפש מרפאות
                            </Button>
                        </Col>
                    </Row>
                </Layout>
            </Form>
        )
    }
}

export default withRouter(SearchBar)
